var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bean-cube"},[_c('div',{staticClass:"bean-cube-list"},_vm._l((_vm.data.beancurdList),function(item,index){return _c('img',{key:index,attrs:{"src":item.beancurdImg,"alt":""},on:{"click":function($event){return _vm.handleClick(item)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }